"use client";
import { useEffect } from "react";
import { AppState } from "@/store/configureStore";
import { clearUserInfo } from "@/store/slices/userSlice";
import { usePathname, useRouter } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import { VALIDATE_LOGIN_TOKEN_API } from "@/constants";
 
const useValidateToken = () => {
	const dispatch = useDispatch();
	const pathName = usePathname();
	const user = useSelector((state: AppState) => state.user);
	const router = useRouter();

	// const base_url = process.env.NEXT_PUBLIC_BASE_URL
 
	useEffect(() => {
		const checkToken = async () => {
			try {
				const response = await fetch(VALIDATE_LOGIN_TOKEN_API, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${user?.token}`,
					},
				});
				if (response.status === 200) {
					const data = await response.json();
					router.push(pathName);
				} else {
					dispatch(clearUserInfo());
					router.push("/login");
				}
			} catch (error: (string | any)) {
				dispatch(clearUserInfo());
				router.push("/login");
			}
		};
		checkToken();
	}, [dispatch, user, pathName, router]);
};

export default useValidateToken;